/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface UserInfo
 */
export class UserInfo {
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    email: string;
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    firstName: string;
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    lastName: string;
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    role: UserInfoRoleEnum;
    /**
     *
     * @type {Array<string>}
     * @memberof UserInfo
     */
    namespaces: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof UserInfo
     */
    ips: Array<string>;
}

/**
 * @export
 * @enum {string}
 */
export enum UserInfoRoleEnum {
    Cicd = 'cicd',
    Admin = 'admin',
    Translator = 'translator',
    Readonly = 'readonly',
    SuccessManagerAgent = 'success_manager_agent',
    SuccessManagerAdmin = 'success_manager_admin',
    Agent = 'agent',
    CryptoAdmin = 'crypto_admin',
}
